import { Box } from '@mui/system'
import { useState, useEffect } from 'react'

const veilStyle = {
  zIndex: 3,
  height: '100vh',
  width: '100vw',
  position: 'absolute',
  top: 0,
  left: 0,
  transition: 'background-color .2s',
  transitionTimingFunction: 'ease-out'
}

interface VeilProps {
  show?: boolean
}
const Veil = ({ show }: VeilProps) => {
  const [alpha, setAlpha] = useState(0)

  useEffect(() => {
    if (show) {
      setAlpha(0.5)
    } else {
      setAlpha(0)
    }
  }, [show])

  return <Box sx={{...veilStyle, backgroundColor: `rgba(0,0,0,${alpha})`, pointerEvents: show ? 'auto' : 'none'}} className="veil" />
}
export default Veil
